// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const HeartFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M48 83.201c-1.495 0-3.376-1.393-4.53-2.171a124.587 124.587 0 0 1-7.831-5.747C22.852 65.125 10.197 51.661 8.58 34.738c-.867-9.082 5.415-17.92 13.946-20.83 9.74-3.322 20.834 1.03 25.474 10.199 4.64-9.17 15.733-13.521 25.474-10.198 8.53 2.91 14.813 11.747 13.946 20.83-1.617 16.922-14.272 30.386-27.059 40.544a124.587 124.587 0 0 1-7.832 5.747C51.376 81.808 49.495 83.2 48 83.2Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default HeartFilled;
